import { Generic } from './Video';
export function isVideo(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isVideo;    //# sourceMappingURL=isVideo.js.map
